/*
 * VigorX v2 — pack selector (snippets/vx-packs.liquid).
 * The only writer of the hidden input[name=quantity] on the product page in v2
 * (vx-quantity.js and vx-bundle-qty-sync.js are not loaded: they mirrored the
 * Vitals widget, which v2 hides, and would overwrite the 4-pack with its tier).
 * Every write dispatches input + change so anything listening hears it.
 */
(function () {
  'use strict';

  /* Hungarian: the noun stays singular after a number (1 doboz, 2 doboz, 4 doboz). */
  function pakiranja(n) {
    return 'doboz';
  }

  function init(box) {
    if (box.__vx) return;
    box.__vx = true;
    var input = document.getElementById(box.getAttribute('data-input'));
    var min = parseInt(box.getAttribute('data-gift-min'), 10) || 4;
    var note = box.querySelector('[data-vx-giftnote]');
    var text = note && note.querySelector('.vx-giftnote__text');
    var bars = note ? [].slice.call(note.querySelectorAll('.vx-giftnote__meter i')) : [];

    function apply(qty) {
      [].forEach.call(box.querySelectorAll('.vx-pack'), function (row) {
        row.classList.toggle('is-on', parseInt(row.getAttribute('data-qty'), 10) === qty);
      });
      if (input && String(input.value) !== String(qty)) {
        input.value = qty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (note) {
        var left = Math.max(min - qty, 0);
        bars.forEach(function (b, i) { b.classList.toggle('is-on', i < qty); });
        note.classList.toggle('is-done', left === 0);
        text.textContent = left === 0
          ? text.getAttribute('data-done')
          : 'Még ' + left + ' ' + pakiranja(left) + ', és ajándékot kapsz';
      }
      box.setAttribute('data-qty', qty);
      var row = box.querySelector('.vx-pack[data-qty="' + qty + '"]');
      if (row) {
        var set = function (sel, v) { var el = box.querySelector(sel); if (el) el.textContent = v; return el; };
        set('[data-vx-total]', row.getAttribute('data-total'));
        set('[data-vx-full]', row.getAttribute('data-full') || '');
        var sv = set('[data-vx-save]', row.getAttribute('data-save') ? 'Megtakarítás ' + row.getAttribute('data-save') : '');
        if (sv) sv.hidden = !row.getAttribute('data-save');
        set('[data-vx-per]', row.getAttribute('data-per'));
        set('[data-vx-qtytxt]', qty + ' ' + pakiranja(qty));
        document.querySelectorAll('[data-vx-sticky-total]').forEach(function (el) { el.textContent = row.getAttribute('data-total'); });
        document.querySelectorAll('[data-vx-sticky-qty]').forEach(function (el) { el.textContent = qty + ' ' + pakiranja(qty) + (qty >= min && note ? ' + 🎁' : ''); });
      }
    }

    box.addEventListener('change', function (e) {
      if (e.target && e.target.name && e.target.name.indexOf('vx-pack-') === 0) apply(parseInt(e.target.value, 10));
    });
    var checked = box.querySelector('input[type=radio]:checked');
    apply(checked ? parseInt(checked.value, 10) : 1);
  }

  /* Mobile sticky buy bar: appears once the real buy button has scrolled away; tapping it
     presses the real button (Releasit COD, or the theme ATC as fallback). */
  function stickyBar() {
    if (document.querySelector('.vx-sticky') || !document.querySelector('[data-vx-packs]')) return;
    var bar = document.createElement('div');
    bar.className = 'vx-sticky';
    var img = document.querySelector('.product__media img');
    var title = document.querySelector('.product__title h1');
    bar.innerHTML = '<div class="vx-sticky__in">' +
      (img ? '<img class="vx-sticky__img" alt="" src="' + (img.currentSrc || img.src) + '">' : '') +
      '<div class="vx-sticky__name">' + (title ? title.textContent.trim() : '') + '</div>' +
      '<div class="vx-sticky__info"><b data-vx-sticky-total></b><span data-vx-sticky-qty></span></div>' +
      '<button type="button" class="vx-sticky__add">Hozzáadás a kosárhoz</button>' +
      '<button type="button" class="vx-sticky__btn">Megrendelés elküldése</button></div>';
    document.body.appendChild(bar);
    var box = document.querySelector('[data-vx-packs]');
    var row = box.querySelector('.vx-pack.is-on');
    if (row) { bar.querySelector('[data-vx-sticky-total]').textContent = row.getAttribute('data-total'); var q = +box.getAttribute('data-qty') || 1; bar.querySelector('[data-vx-sticky-qty]').textContent = q + ' ' + pakiranja(q); }
    bar.querySelector('.vx-sticky__add').addEventListener('click', function () {
      var a = document.querySelector('.product-form__submit'); if (a) a.click();
    });
    bar.querySelector('.vx-sticky__btn').addEventListener('click', function () {
      var b = document.querySelector('#rsi_buy_now_button, .rsi_buy_now_button') || document.querySelector('.product-form__submit');
      if (b) b.click();
    });
    function target() { return document.querySelector('#rsi_buy_now_button, .rsi_buy_now_button') || document.querySelector('.product-form__buttons'); }
    var t = 0;
    function check() {
      t = 0;
      var el = target(); if (!el) return;
      var r = el.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < 0);
    }
    window.addEventListener('scroll', function () { if (!t) t = setTimeout(check, 80); }, { passive: true });
    check();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-vx-packs]'), init); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.vxPacks = { qty: function () { var b = document.querySelector('[data-vx-packs]'); return b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : null; } };
})();
